type UnsavedChangesListener = () => void;

const dirtySources = new Set<symbol>();
const listeners = new Set<UnsavedChangesListener>();
let notificationQueued = false;

export function registerUnsavedChanges(): () => void {
  const source = Symbol('unsaved-changes-source');
  dirtySources.add(source);
  queueNotification();

  let registered = true;
  return () => {
    if (!registered) return;
    registered = false;
    dirtySources.delete(source);
    queueNotification();
  };
}

export function hasUnsavedChanges(): boolean {
  return dirtySources.size > 0;
}

export function subscribeUnsavedChanges(
  listener: UnsavedChangesListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function queueNotification(): void {
  if (notificationQueued) return;
  notificationQueued = true;
  queueMicrotask(() => {
    notificationQueued = false;
    for (const listener of [...listeners]) {
      if (listeners.has(listener)) listener();
    }
  });
}
